import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useIsWorkerRequirementsSearchEnabled() {
  return useCbhFlag(CbhFeatureFlag.WORKER_REQUIREMENTS_SEARCH, {
    defaultValue: false,
  });
}
